import Image from 'next/image'
import { useMemo } from 'react'

interface ProductReviewsRatingStarsProps {
  rating: number
  className?: string
}

export const ProductReviewsRatingStars = ({
  rating = 0,
  className = '',
}: ProductReviewsRatingStarsProps) => {
  const MAX_RATING = 5

  const stars = useMemo(() => {
    const avgRating = rating > MAX_RATING ? Math.min(rating, 10) / 2 : rating

    const fullStars = Math.floor(avgRating)
    const hasHalfStar = avgRating % 1 !== 0
    const emptyStars = MAX_RATING - Math.ceil(avgRating)

    return {
      full: Array(fullStars).fill(null),
      half: hasHalfStar ? [null] : [],
      empty: Array(emptyStars).fill(null),
    }
  }, [rating])

  if (!rating) return null

  return (
    <div className={`flex items-center gap-1 lg:gap-2 ${className}`}>
      {stars.full.map((_, index) => (
        <Image
          key={`full-${index}`}
          src='/icons/product/icon-star-gold.svg'
          width={23}
          height={23}
          alt='full-star'
          className='lg:h-11 lg:w-11'
        />
      ))}

      {stars.half.map((_, index) => (
        <Image
          key={`half-${index}`}
          src='/icons/product/icon-star-gold-half.svg'
          width={23}
          height={23}
          alt='half-star'
          className='mt-0.5 scale-110 lg:mt-1.5 lg:h-11 lg:w-11 lg:scale-[1.16]'
        />
      ))}

      {stars.empty.map((_, index) => (
        <Image
          key={`empty-${index}`}
          src='/icons/product/icon-star-none.svg'
          width={23}
          height={23}
          alt='empty-star'
          className='lg:h-11 lg:w-11'
        />
      ))}
    </div>
  )
}
